import { render, staticRenderFns } from "./FirmBasedata.vue?vue&type=template&id=e65a3684"
import script from "./FirmBasedata.vue?vue&type=script&lang=js"
export * from "./FirmBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports